import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    eyebrow: "Juego diario",
    title: "La palabra del día",
    body: "Adivina la palabra de hoy sobre eventos, fiestas y música. 6 intentos, una nueva cada día.",
    short: "¿La adivinas en 6 intentos? Una nueva cada día.",
    play: "Jugar ahora",
  },
  en: {
    eyebrow: "Daily game",
    title: "Word of the day",
    body: "Guess today's word about events, parties and music. 6 tries, a new one every day.",
    short: "Can you guess it in 6 tries? A new one every day.",
    play: "Play now",
  },
});
